<template>
  <div>
    <CCardHeader class="p-1 pt-0">
      <CRow>
        <CCol col="8" style="text-align: start ;">

          <strong v-if="status_form==0">{{ $t("BaseSettings") }}</strong>

        </CCol>
        <CCol col="4" style="text-align: end">

          <CButton
                  class="mr-1 ml-1"
                  v-if="status_form==0" @click="insert_data()"
              size="sm"
              color="secondary"
          >{{ $t("buttons.submit") }}
          </CButton>
          <CButton
                  class="mr-1 ml-1"
                  v-if="status_form!=0" @click="insert_data()"
              size="sm"
              color="secondary"
          >{{ $t("buttons.edit") }}
          </CButton>


        </CCol>
      </CRow>
    </CCardHeader>

    <CRow>
      <CCol col="12">
        <CCard>
          <CCardHeader>
            <CRow>
              <CCol col="2">
                <strong>{{$t('DetermineAccess')}}</strong>
              </CCol>
              <CCol col="4">
                <CInput
                        :label="$t('userGroups')"
                        :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                        v-model="name"
                        autocomplete="name"
                />
              </CCol>
              <CCol col="4">
                <CSelect
                    :label="$t('components.roleGroup')"
                    :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                    :options="role_groups"
                    :value.sync="selected_role_groups"/>
              </CCol>
            </CRow>
          </CCardHeader>

        </CCard>

      </CCol>

    </CRow>
    <CRow>
      <CCol col="12">
        <CCard>
<!--          <CCardHeader>-->
<!--            <CRow>-->
<!--              <CCol col="2">-->
<!--                <strong>{{ $t('components.roleGroupList') }}</strong>-->
<!--              </CCol>-->
<!--             -->
<!--            </CRow>-->
<!--          </CCardHeader>-->
<!--          <CRow>-->
<!---->
<!--          </CRow>-->
          <CCardBody>
            <CDataTableFixed
                :items="filtered_role_items"
                :fields="fields"
                add-table-classes="width-2000 overfly-x-auto"
                :items-per-page="20"
                hover
                border
                height="300px"
                pagination
            >

              <template #access_name="{item}">

                <td v-if="$i18n.locale=='fa'" style="position: sticky;right: 0;background: white">
                  <p >{{ item.operationName }}</p>
                </td>
                <td v-if="$i18n.locale!='fa'" style="position: sticky;left: 0;background: white">
                  <p >{{ item.operationName }}</p>
                </td>

              </template>
              <template v-for="(group_item , index2) in items" v-slot:[get_group_name(index2)]="{item}">

                <td class="text-center">
                  <CIcon @click.native="remove_permission_item(index2,item)"
                         v-if="group_item.rols.includes(item.id)" class="text-success" name="cil-check"/>
                  <CIcon @click.native="add_permission_item(index2,item)" v-else name="cil-check"/>

                </td>
              </template>
              <template v-for="(group_item , index2) in items" v-slot:[get_group_header(index2)]>
                <CRow class="m-0 text-center">

                  <CIcon addWrapperClasses="m-0  p-0" addInputClasses="m-0  p-0" v-c-tooltip="{
        content: $t('changeStatus'),
        placement: 'bottom-start'
      }" @click.native="delete_item_dialog(group_item)" size="sm" class="p-0 m-0" name="cil-trash"/>

                  <CIcon addWrapperClasses="m-0 p-0 " addInputClasses="m-0  p-0" @click.native="edit_data(group_item)"
                         class=" p-0 m-0 mr-2" size="sm" name="saveNew"/>

                  <CInput addWrapperClasses="m-0" class="m-0" addInputClasses="text-center"
                          :value.sync="group_item.groupName"/>
                  <!--                 <CInput addWrapperClasses="m-0" class="m-0" :disabled="true">-->
                  <!--                    <template #append-content >-->
                  <!--                      <CIcon addWrapperClasses="m-0 p-0" addInputClasses="m-0  p-0"  @click.native="edit_data(group_item)" class="p-0 m-0"  size="sm" name="cil-save"/>-->
                  <!--                    </template>-->
                  <!--                    <template #prepend-content  class="dark">-->
                  <!--                        <CIcon addWrapperClasses="m-0  p-0" addInputClasses="m-0  p-0"  @click.native="delete_item_dialog(group_item)" size="sm" class="p-0 m-0" name="cil-bolt"/>-->
                  <!--                    </template>-->
                  <!--                  </CInput>-->
                </CRow>
                <CRow class="m-0 text-center">
                </CRow>
                <!--                </td>-->
              </template>


            </CDataTableFixed>
          </CCardBody>
          <CCardFooter>

          </CCardFooter>
        </CCard>

      </CCol>

    </CRow>

  </div>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';

var items = [];
var items_role = [];


export default {
  name: 'Login',
  data() {
    return {
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,

      name: '',
      file: '',
      color: '#ffffff',
      previewImage: '',
      description: '',
      role_groups: [],
      selected_role_groups: 0,
      items: items.map((item, row_id) => {
        return {...item, row_id}
      }),
      role_items: [],
      filtered_role_items: [],
      fields: [],
      fields_role: [
        {key: 'operationName', label: this.$t('operationType'), _style: 'width:20%'},
        {key: 'role', filter: false, label: this.$t('tables.role'), _style: 'width:20%'},
      ],
      role_checkbox_items: [],
      details: [],
      collapseDuration: 0,
      status_form: 0
    }
  }, mounted() {
    this.$root.root_validate_errors = [];

    this.get_lists();
    this.get_roles();
    this.get_groups();

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
  }, watch: {
    'selected_role_groups': function () {
      // if (this.selected_role_groups == 0) {
      //   this.filtered_role_items = this.role_items;
      // } else {
        this.filtered_role_items = this.role_items.filter(item => item.parentId == this.selected_role_groups);

      // }
    }
  },
  methods: {
    add_permission_item(index,item){
var self = this;
      this.items[index].rols.push(item.id)
      // console.log(item)
      this.role_items.filter(x => x.parentId == item.id).forEach(function (val){
        // console.log(val);
        self.items[index].rols.push(val.id)
      })
    },
    remove_permission_item(index,item){
      var self = this;

      this.items[index].rols.splice(this.items[index].rols.indexOf(item.id),1)
      this.role_items.filter(x => x.parentId == item.id).forEach(function (val){
        // console.log(val);
        self.items[index].rols.splice(self.items[index].rols.indexOf(val.id),1)

        // self.items[index].rols.push(val.id)
      })
    },
    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.role_checkbox_items.length > 0) {
        return true;
      }


      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.role_checkbox_items.length == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.selectRoles'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    get_group_name(index) {
      return "group_" + index
    },
    get_group_header(index) {
      return "group_" + index + "-header"
    },
    edit_item(item) {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.role_checkbox_items = [];

      this.status_form = this.items[item.row_id].id;
      this.get_role_info();

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    }, emptyList() {
      // this.$set(this.items[item.id], '_toggled', !item._toggled)
      this.name = '';
      this.role_checkbox_items = [];
      this.description = '';
      this.previewImage = '';
      this.status_form = 0;

      // this.$nextTick(() => {
      //     this.collapseDuration = 0
      // })
    },
    get_lists() {
      var self = this;


      const formData = new FormData();

      // formData.append('id', this.selected_province);

      axios.post('GetUserGroupTitles', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.items = content_data.data.map((item, row_id) => {
            return {...item, row_id}
          });
          self.fields = []

          self.fields.push({key: 'access_name', label: self.$t('operationType'), _style: 'width:10%;text-align:center'})

          for (var i = 0; i < content_data.data.length; i++) {
            self.fields.push({key: 'group_' + i, label: content_data.data[i].groupName, _style: ''})
          }

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_roles() {
      var self = this;

      const formData = new FormData();

      axios.post('GetOperationSystems', formData, {}).then(function (response) {

        var content = response.data;

        // items = content_cats.orders;
        self.role_items = content.data.map((item, row_id) => {
          return {...item, row_id}
        });
        self.filtered_role_items = self.role_items.filter(item => item.parentId == self.selected_role_groups);

        // self.filtered_role_items = self.role_items
      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_groups() {
      var self = this;

      const formData = new FormData();

      axios.post('GetOperationParents', formData, {}).then(function (response) {

        var content = response.data;

        // items = content_cats.orders;
        // self.role_groups = content.data.map((item, row_id) => {
        //   return {...item, row_id}
        // });
        self.role_groups = [];
        self.role_groups = content.data.map(({id, title}) => ({label: title, value: id}));
        self.role_groups.splice(0, 0, {label: self.$t('permissionModules'), value: 0});

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_role_info() {
      var self = this;

      const formData = new FormData();
      formData.append("id", self.status_form);
      axios.post('GetGroupTitleById', formData, {}).then(function (response) {

        var content = response.data;
        self.role_checkbox_items = []

        self.name = content.data.groupInfo.groupName;
        content.data.operationSystems.forEach((val) => {
          self.role_checkbox_items.push(val.rolId);
        });
        //  self.role_checkbox_items =  content.data.groupInfo.groupName;

        // items = content_cats.orders;

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    goSubCategories(item, index) {

      this.$router.push({path: '/categories/' + this.items[index].id});
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    edit_data(group_item) {

      let self = this;

      const formData = new FormData();
      let url;

      url = "EditGroupTitle";
      formData.append('id', group_item.id)

      group_item.rols.forEach((val) => {
        // OperationSystems.push({val});
        formData.append('OperationSystems', val);

      });
      // console.log("json group"+ JSON.stringify(person));
      formData.append('groupName', group_item.groupName);
      // formData.append('OperationSystems',  OperationSystems);
      axios.post(url, formData, {}).then((res) => {


        self.$root.modal_component.show_api_response_modals(res)
        // self.status_form = 0;
        // self.name = '';
        // self.role_checkbox_items = [];
        // self.description = '';
        // self.previewImage = '';
        // self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_data() {
      let self = this;

      if(self.name==''){
        return false;
      }
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddGroupTitle";
      } else {
        url = "EditGroupTitle";
        formData.append('id', this.status_form)

      }
      // var person = new Object();
      // person.groupName = self.name;
      self.role_checkbox_items.forEach((val) => {
        // OperationSystems.push({val});
        formData.append('OperationSystems', val);

      });
      // console.log("json group"+ JSON.stringify(person));
      formData.append('groupName', self.name);
      // formData.append('OperationSystems',  OperationSystems);
      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res)
        self.status_form = 0;
        self.name = '';
        self.role_checkbox_items = [];
        // self.description = '';
        // self.previewImage = '';
        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = this.items[item.row_id].id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteGroupTitle";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
